/**
 * @file AddEditUserDialog.jsx
 * @description AddEditUserDialog component for displaying and managing add edit user dialog.
 * @component AddEditUserDialog
 * @exports AddEditUserDialog - Main component for displaying and managing add edit user dialog.
 */

import React from "react";
import { Button, TextField, FormControl, InputLabel, Select, MenuItem, Box } from "@mui/material";
import { USER_STRINGS, USER_KEYS } from "../../../common/constants/adminModule/userConstants.js";
import { STRINGS, SIZES, VARIANTS, BUTTON_COLORS, AUTO_COMPLETE } from "../../../common/constants/commonConstants.js";
import DialogComponent from "../../../common/components/DialogComponent.jsx";

const AddEditUserDialog = ({
    userRoles,
    onSave,
    selectedUser,
    open,
    handleInputChange,
    onClose,
}) => {
    return (
        <>
            <DialogComponent
                open={open}
                setWidth="xs"
                onClose={onClose}
                title={selectedUser?.id ? USER_STRINGS.EDIT_USER : USER_STRINGS.ADD_USER}
                actions={
                    <Button
                        onClick={onSave}
                        variant={VARIANTS.CONTAINED}
                        color={BUTTON_COLORS.PRIMARY}
                    >
                        {STRINGS.SAVE}
                    </Button>
                }
            >
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                    <TextField
                        fullWidth
                        size={SIZES.SMALL}
                        variant={VARIANTS.OUTLINED}
                        label={USER_STRINGS.FIRST_NAME}
                        autoComplete={AUTO_COMPLETE.OFF}
                        value={selectedUser?.firstname || ""}
                        onChange={handleInputChange(USER_KEYS.FIRST_NAME)}
                    />
                    <TextField
                        fullWidth
                        size={SIZES.SMALL}
                        variant={VARIANTS.OUTLINED}
                        label={USER_STRINGS.LAST_NAME}
                        autoComplete={AUTO_COMPLETE.OFF}
                        value={selectedUser?.lastname || ""}
                        onChange={handleInputChange(USER_KEYS.LAST_NAME)}
                    />
                    <TextField
                        fullWidth
                        size={SIZES.SMALL}
                        label={USER_STRINGS.EMAIL}
                        variant={VARIANTS.OUTLINED}
                        autoComplete={AUTO_COMPLETE.OFF}
                        value={selectedUser?.emailaddress || ""}
                        onChange={handleInputChange(USER_KEYS.EMAIL_ADDRESS)}
                    />
                    <FormControl fullWidth size={SIZES.SMALL}>
                        <InputLabel>{USER_STRINGS.ROLE}</InputLabel>
                        <Select
                            label={USER_STRINGS.ROLE}
                            value={selectedUser?.roleid || ""}
                            onChange={handleInputChange(USER_KEYS.ROLE_ID)}
                        >
                            {userRoles.map((userRole) => (
                                <MenuItem key={userRole.id} value={userRole.id}>
                                    {userRole.rolename}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>
            </DialogComponent>
        </>
    )
};

export default AddEditUserDialog;